"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropdownDocument = void 0;
var types_1 = require("../../../types");
exports.dropdownDocument = {
    dateCreated: "2021-07-26T19:09:11Z",
    form: {
        id: 1196401,
        displayConditions: [],
        name: "Some Text Inputs and Dropdowns",
        rootId: 1196401,
        sections: [
            {
                id: 1191902,
                items: [
                    {
                        answerSource: {
                            dataSourceKey: "123423",
                            type: "DATA_SOURCE",
                        },
                        id: 1192002,
                        properties: {
                            placeHolderText: "Colors Placeholder",
                        },
                        rootId: 1192002,
                        subType: "DROP_DOWN",
                        title: "Colors",
                        type: "QUESTION",
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: {
                            dataSourceKey: "WORK_LOCATION",
                            type: "DATA_SOURCE",
                        },
                        id: 1192003,
                        properties: {
                            placeHolderText: "Work Locations Placeholder",
                        },
                        rootId: 1192003,
                        subType: "DROP_DOWN",
                        title: "Work Locations",
                        type: "QUESTION",
                        workflowType: "FINAL",
                    },
                    {
                        id: 1192004,
                        properties: {
                            placeHolderText: "Custom Placeholder",
                        },
                        rootId: 1192004,
                        selections: [
                            {
                                id: 1192252,
                                rootId: 1192252,
                                title: "Option 2",
                            },
                            {
                                id: 1192251,
                                rootId: 1192251,
                                title: "Option 1",
                            },
                        ],
                        subType: "DROP_DOWN",
                        title: "Custom",
                        type: "QUESTION",
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: {
                            dataSourceKey: "WORK_LOCATION",
                            type: "DATA_SOURCE",
                        },
                        id: 1192005,
                        properties: {
                            placeHolderText: "More Work Locations Placeholder",
                        },
                        rootId: 1192301,
                        subType: "DROP_DOWN",
                        title: "More Work Locations",
                        type: "QUESTION",
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: null,
                        formProperties: {
                            id: 1210561,
                            isCloneable: true,
                            isRequired: false,
                            isSearchable: false,
                            questionRootId: 1210702,
                        },
                        hasDefenses: false,
                        id: 1210702,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-08-11T16:57:29.895133Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: {
                            placeHolderText: "Selected Color Placeholder",
                        },
                        rootId: 1210702,
                        selections: [],
                        subType: "TEXT_LINE",
                        tags: [],
                        title: "Selected Color",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                ],
                rootId: 1191901,
                title: "Some Dropdowns",
                workflowType: "FINAL",
            },
        ],
        type: {
            active: true,
            id: 1,
            name: "Head Scratchers",
            isGlobal: true,
        },
        workflowType: "FINAL",
    },
    formActionRequests: [],
    formSummary: {
        id: 1196401,
        name: "Some Dropdowns",
        rootId: 1196401,
        type: {
            active: true,
            id: 1,
            name: "Head Scratchers",
            isGlobal: true,
        },
        workflowType: "FINAL",
    },
    id: 1201151,
    operationalExperiences: [],
    owner: {
        fullName: 'Riley, Todd "The Toddster"',
        name: "Todd Riley",
        participantId: 1062251,
    },
    participants: [],
    photos: [],
    readOnly: false,
    responses: [],
    resubmissions: [],
    sectionComments: [],
    startDate: "2021-07-26T19:09:11Z",
    status: types_1.DocumentStatus.NEW,
    submissionDate: "2021-07-26T19:09:11Z",
    submissionId: 1201201,
    submissionType: types_1.DocumentSubmissionType.NEW,
    summary: {},
    title: "New Document",
};
//# sourceMappingURL=dropdownDocument.js.map